import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {
  transform<T>(array: T[], field: keyof T): { key: any, items: T[] }[] {
    if (!array) return [];
    const grouped: { [key: string]: T[] } = {};

    array.forEach(item => {
      const key = item[field] as any;
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });

    return Object.keys(grouped).map(key => ({
      key,
      items: grouped[key]
    }));
  }
}
